module.exports = __webpack_public_path__ + "static/media/demo.ee4a204f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/app/usecase-watch/assets/demo.mp4
// module id = 64
// module chunks = 0